import React from 'react';

import Button from '@material-ui/core/Button';
import CardActions from '@material-ui/core/CardActions';
import CardContent from '@material-ui/core/CardContent';
import clsx from 'clsx';
import Collapse from '@material-ui/core/Collapse';
import { Grid } from '@material-ui/core';
import IconButton from '@material-ui/core/IconButton';
import PropTypes from 'prop-types';
import Typography from '@material-ui/core/Typography';

import TimelineItem from '@material-ui/lab/TimelineItem';
import TimelineSeparator from '@material-ui/lab/TimelineSeparator';
import TimelineConnector from '@material-ui/lab/TimelineConnector';
import TimelineContent from '@material-ui/lab/TimelineContent';
import Tooltip from '@material-ui/core/Tooltip';
import TimelineDot from '@material-ui/lab/TimelineDot';
import { formStyles } from 'consts/styles/Form';
import { useSelector } from 'react-redux';

import Icons from 'consts/icons';

import ButtonsUseStyles from 'consts/styles/Buttons';
import OrganizationMap from './OrganizationMapRender/OrganizationMapRender';
import useOrganizationsStyles from '../ExistingOrganizationsUseSharedStyles';
import useStyles from './OrganizationsTreeViewUseStyles';

const OrganizationTreeView = props => {
  const {
    organization,
    childArray,
    handleExpandClickChildren,
    expandedCards,
    onParentOrganizationSelect,
    onOrganizationToEditSelect,
    headOrganizationParent,
  } = props;
  const useString = () => {
    const language = useSelector(state => state.language);
    return language;
  };
  const [subtitles] = React.useState(useString().adminZone);
  const organizationsClasses = useOrganizationsStyles();

  const classes = useStyles();
  const formClasses = formStyles();
  const classesButtons = ButtonsUseStyles();

  const onAdd = area => {
    onParentOrganizationSelect(area);
    onOrganizationToEditSelect(null);
  };

  const onEdit = organizationToEdit => {
    onParentOrganizationSelect(null);
    onOrganizationToEditSelect(organizationToEdit);
  };

  const returnExistingOrgCard = renderedOrganization => (
    <CardContent
      className={`${formClasses.Form}__card ${formClasses.Form}__text-field`}
      key={renderedOrganization.uid}
    >
      <Grid container>
        <Grid item xs={5}>
          <Typography
            className={`${classes.OrganizationTreeView}__title--font-size`}
            gutterBottom
          >
            {renderedOrganization.parent
              ? subtitles.addOrganization.existingOrgs.slaveOrgTitle_
              : subtitles.addOrganization.existingOrgs.orgTitle_}
          </Typography>
          <Typography variant="h5" component="h2">
            {renderedOrganization.name}
          </Typography>
          <Typography variant="body2" component="p">
            {subtitles.addOrganization.existingOrgs.city_}:{' '}
            {renderedOrganization.address.city}
            <br />
            {subtitles.addOrganization.existingOrgs.street_}:{' '}
            {renderedOrganization.address.street}
            <br />
            {subtitles.addOrganization.existingOrgs.number_}:{' '}
            {renderedOrganization.address.number}
            <br />
            {subtitles.addOrganization.existingOrgs.phone_}:{' '}
            {renderedOrganization.phone}
          </Typography>
        </Grid>
        <Grid item xs={5}>
          <OrganizationMap
            organization={renderedOrganization}
          ></OrganizationMap>
        </Grid>

        <Grid item xs={2}>
          <Grid
            container
            align="right"
            alignItems="center"
            justifyContent="space-around"
            style={{ height: '100%' }}
          >
            <Grid item xs={12}>
              <Tooltip
                title={subtitles.addOrganization.preview_}
                placement="left"
              >
                <Button
                  type="button"
                  fullWidth
                  onClick={() => onEdit(renderedOrganization)}
                  className={`${classesButtons.Buttons} ${classesButtons.Buttons}--color ${classesButtons.ButtonsCircle}`}
                >
                  <Icons.Actions.Preview />
                </Button>
              </Tooltip>
            </Grid>
            <Grid item xs={12}>
              {(Object.prototype.hasOwnProperty.call(
                renderedOrganization,
                'grandChildOrganizations'
              ) ||
                !renderedOrganization.master) && (
                <Tooltip
                  title={subtitles.addOrganization.formFields.addButton_}
                  placement="left"
                >
                  <Button
                    type="button"
                    fullWidth
                    className={`${classesButtons.Buttons} ${classesButtons.Buttons}--color ${classesButtons.ButtonsCircle}`}
                    onClick={() => onAdd(renderedOrganization)}
                  >
                    <Icons.Actions.Add2 />
                  </Button>
                </Tooltip>
              )}
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </CardContent>
  );

  return (
    <div>
      {childArray.length ? (
        <Grid container>
          <Grid item xs={organization.parent ? 1 : false}>
            {childArray[childArray.length - 1].uid === organization.uid ? (
              <TimelineItem
                classes={{
                  missingOppositeContent: `${classes.OrganizationTreeView}__timeline`,
                }}
              >
                <TimelineSeparator
                  classes={{
                    root: `${classes.OrganizationTreeView}__timeline ${classes.OrganizationTreeView}__timeline--end`,
                  }}
                >
                  <TimelineConnector
                    classes={{
                      root: `${formClasses.Form}__switch__track`,
                    }}
                  />
                  <TimelineDot style={{ backgroundColor: 'initial' }}>
                    <Icons.Misc.RadioChecked />
                  </TimelineDot>
                </TimelineSeparator>

                <TimelineContent
                  classes={{
                    root: `${classes.OrganizationTreeView}__timeline`,
                  }}
                />
              </TimelineItem>
            ) : (
              <>
                <TimelineItem
                  classes={{
                    missingOppositeContent: `${classes.OrganizationTreeView}__timeline`,
                  }}
                >
                  {!headOrganizationParent ? (
                    <>
                      <TimelineSeparator>
                        <TimelineConnector
                          classes={{
                            root: `${formClasses.Form}__switch__track`,
                          }}
                        />
                        <TimelineDot
                          classes={{
                            defaultGrey: `${formClasses.Form}__select__menu--background-color`,
                          }}
                        />
                        <TimelineConnector
                          classes={{
                            root: `${formClasses.Form}__switch__track`,
                          }}
                        />
                      </TimelineSeparator>
                      <TimelineContent
                        classes={{
                          root: `${classes.OrganizationTreeView}__timeline`,
                        }}
                      />
                    </>
                  ) : null}
                </TimelineItem>
              </>
            )}
          </Grid>
          <Grid item xs={organization.parent ? 11 : 12}>
            {returnExistingOrgCard(organization)}
          </Grid>
        </Grid>
      ) : (
        <Grid item xs={12}>
          {returnExistingOrgCard(organization)}
        </Grid>
      )}

      {organization.grandChildOrganizations && (
        <div>
          <Grid container>
            <Grid item xs={1}>
              {childArray[childArray.length - 1].uid === organization.uid ? (
                <div></div>
              ) : (
                <TimelineItem
                  classes={{
                    missingOppositeContent: `${classes.OrganizationTreeView}__timeline`,
                  }}
                >
                  <TimelineSeparator>
                    <TimelineConnector
                      classes={{
                        root: `${formClasses.Form}__switch__track`,
                      }}
                    />
                    <TimelineConnector
                      classes={{
                        root: `${formClasses.Form}__switch__track`,
                      }}
                    />
                  </TimelineSeparator>
                  <TimelineContent
                    classes={{
                      root: `${classes.OrganizationTreeView}__timeline`,
                    }}
                  />
                </TimelineItem>
              )}
            </Grid>
            {organization.grandChildOrganizations.length ? (
              <Grid
                item
                xs={11}
                className={`${formClasses.Form}__card--lower-bottom`}
              >
                <CardActions
                  onClick={() => handleExpandClickChildren(organization.uid)}
                  className={`${formClasses.Form}__card ${formClasses.Form}__card--box-shadow ${formClasses.Form}__text-field--black ${formClasses.Form}__tabs__button`}
                  disableSpacing
                >
                  <Typography variant="h5">
                    {subtitles.addOrganization.existingOrgs.expandTitleSlaves_}
                  </Typography>
                  <IconButton
                    className={clsx(
                      `${organizationsClasses.ExistingWithTree}__expand-bar__arrow`,
                      {
                        [`${organizationsClasses.ExistingWithTree}__expand-bar__arrow--open`]: expandedCards[
                          organization.uid
                        ],
                      }
                    )}
                    aria-label="Show organizations"
                  >
                    <Icons.Navigation.Down />
                  </IconButton>
                </CardActions>
                {organization.grandChildOrganizations.map(
                  (eachGrandOrg, index) => (
                    <Collapse
                      key={index}
                      unmountOnExit
                      in={expandedCards[organization.uid]}
                      className={`${classes.OrganizationTreeView}__organization--padding-left`}
                    >
                      <Grid container>
                        {organization.grandChildOrganizations[
                          organization.grandChildOrganizations.length - 1
                        ].uid === eachGrandOrg.uid ? (
                          <Grid item xs={1}>
                            <TimelineItem
                              classes={{
                                missingOppositeContent: `${classes.OrganizationTreeView}__timeline`,
                              }}
                            >
                              <TimelineSeparator
                                classes={{
                                  root: `${classes.OrganizationTreeView}__timeline ${classes.OrganizationTreeView}__timeline--end`,
                                }}
                              >
                                <TimelineConnector
                                  classes={{
                                    root: `${formClasses.Form}__switch__track`,
                                  }}
                                />
                                <TimelineDot
                                  style={{ backgroundColor: 'initial' }}
                                >
                                  <Icons.Misc.RadioChecked />
                                </TimelineDot>
                              </TimelineSeparator>

                              <TimelineContent
                                classes={{
                                  root: `${classes.OrganizationTreeView}__timeline`,
                                }}
                              />
                            </TimelineItem>
                          </Grid>
                        ) : (
                          <Grid item xs={1}>
                            <TimelineItem
                              classes={{
                                missingOppositeContent: `${classes.OrganizationTreeView}__timeline`,
                              }}
                            >
                              {!headOrganizationParent ? (
                                <>
                                  <TimelineSeparator>
                                    <TimelineConnector
                                      classes={{
                                        root: `${formClasses.Form}__switch__track`,
                                      }}
                                    />
                                    <TimelineDot
                                      classes={{
                                        defaultGrey: `${formClasses.Form}__select__menu--background-color`,
                                      }}
                                    />
                                    <TimelineConnector
                                      classes={{
                                        root: `${formClasses.Form}__switch__track`,
                                      }}
                                    />
                                  </TimelineSeparator>
                                  <TimelineContent
                                    classes={{
                                      root: `${classes.OrganizationTreeView}__timeline`,
                                    }}
                                  />
                                </>
                              ) : null}
                            </TimelineItem>
                          </Grid>
                        )}
                        <Grid item xs={11}>
                          {returnExistingOrgCard(eachGrandOrg)}
                        </Grid>
                      </Grid>
                    </Collapse>
                  )
                )}
              </Grid>
            ) : null}
          </Grid>
        </div>
      )}
    </div>
  );
};
OrganizationTreeView.propTypes = {
  handleExpandClickChildren: PropTypes.func.isRequired,
  organization: PropTypes.object.isRequired,
  childArray: PropTypes.array.isRequired,
  expandedCards: PropTypes.object.isRequired,
  onParentOrganizationSelect: PropTypes.func.isRequired,
  onOrganizationToEditSelect: PropTypes.func.isRequired,
  headOrganizationParent: PropTypes.oneOfType([
    PropTypes.object,
    PropTypes.string,
  ]),
};

export default OrganizationTreeView;
